import React from 'react';
import type { ProjectKey } from '@atlassian/jira-common-navigation/src/get-scope-data/types.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import OpTrigger from '@atlassian/jira-common-util-op-triggers/src/on-mount/OpTrigger.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

type Props = {
	// @deprecated baseUrl is always '', remove it from your packages: go/baseurl-cleanup-jfe
	baseUrl?: string;
	projectKey: ProjectKey;
};

export const addProjectToHistory = (projectKey: ProjectKey) =>
	performPostRequest(`/rest/internal/2/project/${projectKey}/recent`).catch((e) => {
		log.safeErrorWithoutCustomerData(
			'spa-apps.common.src.add-project-to-history',
			'Cannot set recent project',
			e,
		);
	});

const AddProjectToHistory = ({ projectKey }: Props) => (
	<OpTrigger op={() => addProjectToHistory(projectKey)} />
);

export default AddProjectToHistory;
